import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "view-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "heading-title" }, "Documents", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "heading-subtitle gi-document-subtitle" }, " Upload all relevant files, including insurance plan enrollment applications and any other forms mentioned in the notice letter, by clicking the \"Choose file\" button or dragging and dropping them into the upload area. ", -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  id: "required-doc-container"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", {
  class: "heading-subtitle",
  style: {"margin-bottom":"5px"}
}, " Please upload the following required documents to process your enrollment: ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { id: "upload-file-message" }, "Please upload any relevant files below:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RequiredDocument = _resolveComponent("RequiredDocument")!
  const _component_DocumentUploadDragAndDrop = _resolveComponent("DocumentUploadDragAndDrop")!
  const _component_AppFooter = _resolveComponent("AppFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      (_ctx.validationMsg)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "alert alert-danger",
            innerHTML: _ctx.validationMsg
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true),
      (_ctx.documents != undefined && _ctx.documents != null && _ctx.documents.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _hoisted_6,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documents, (document, index) => {
              return (_openBlock(), _createBlock(_component_RequiredDocument, {
                key: index,
                document: document,
                loopIndex: index,
                onRefreshData: _ctx.loadData,
                onSetValidationMessage: _ctx.setValidationMessage
              }, null, 8, ["document", "loopIndex", "onRefreshData", "onSetValidationMessage"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _hoisted_7,
      _createVNode(_component_DocumentUploadDragAndDrop, { onSetValidationMessage: _ctx.setValidationMessage }, null, 8, ["onSetValidationMessage"])
    ]),
    _createVNode(_component_AppFooter, {
      "save-btn-txt": _ctx.getDocumentSubmitBtn,
      "is-form-invalid": false,
      "is-submit-disabled": _ctx.isSubmitDisabled,
      onSubmitHandler: _ctx.submitHandler
    }, null, 8, ["save-btn-txt", "is-submit-disabled", "onSubmitHandler"])
  ], 64))
}